import type { useProgress } from '@hooks/useProgress'
import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { Activiteit } from '../types//Activiteit'

export { createActiviteitenForEntity }

const createActiviteitenForEntity = async ({
  entity: { type, id },
  activiteiten,
  progress,
}: {
  entity: Entity
  activiteiten: Partial<Activiteit>[]
  progress: ReturnType<typeof useProgress>
}) => {
  try {
    progress.set({
      current: progress.current,
      total: progress.total,
      error: progress.error,
    })

    for (const activiteitInfo of activiteiten) {
      await apiClient({
        url: `/rest/${type}/${id}/activiteit`,
        method: 'POST',
        data: activiteitInfo,
      })
      progress.bump()
    }
  } catch (error: any) {
    progress.fail()
    throw error
  }
}
